
<script>
    import Logo from '../../components/logo/logo.svelte'
    import userStore from '../../store/user/user'

    let user = {}

    userStore.subscribe(value => {
        user = value
    })
</script>

<style lang="scss">
	.logo {
		text-align: center;
        margin-top: 42px;
	}
	.logout {
	    float: right;
	    margin-top: -30px;
	    color: #808683;
	    cursor: pointer;
	    text-decoration: underline;
	    &:hover {
	        text-decoration: none;
	    }
	}
</style>

<main>
    {#if user.isLogged}
    <div class="logout" on:click={userStore.logout}>Logout</div>
    {/if}
    <div class="logo">
            <Logo />
        </div>
    <slot />
</main>
